<!--确认安装详细页-->
<template>
    <div>
        <van-sticky>
            <div style="padding: 10px 0px 0px 0px">
                <van-icon name="arrow-left" size="20px" @click="onback"/>
            </div>
        </van-sticky>
        <div class="content">
            <Card style="width:100%">
                <cell size="small" style="padding: 0px;">
                    <label>订单号：
                        <label style="color: #0077aa;">{{installlist.orderNum}}</label>
                    </label><br/>
                </cell>

                <div class="mid">
                                <span class="count fl">车牌号:
                                    <label style="color: #0077aa;">{{installlist.vehicleInfo==null?installlist.tempVehicleInfo.registrationNum:installlist.vehicleInfo.registrationNum}}</label>
                                    <!--                                    <label style="color: #0077aa;">{{installlist.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                    <span class="distance fr">|</span>
                    <span class="count fl">车辆识别码:
                                    <label style="color: #0077aa;">{{installlist.vehicleInfo==null?installlist.tempVehicleInfo.identificationCode:installlist.vehicleInfo.identificationCode}}</label>
                        <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                    <span class="distance fr">|</span>
                    <span class="time fr">车架号:
                                    <label style="color: #0077aa;">{{installlist.vehicleInfo==null?installlist.tempVehicleInfo.vin:installlist.vehicleInfo.vin}}</label>
                                </span>
                </div>
                <div class="mid">
                                <span class="count fl">发动机号:
                                    <label style="color: #0077aa;">{{installlist.vehicleInfo==null?installlist.tempVehicleInfo.engineNum:installlist.vehicleInfo.engineNum}}</label>
                                </span>
                </div>

                <div class="mid">
                    <span class="count fl">创建时间:<label style="color: #0077aa;">{{installlist.createDatetime == null?'无':new Date(installlist.createDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}</label></span>
                </div>

                <div class="mid">
                    <span class="count fl">安装状态:<label
                            style="color: #0077aa;">{{installlist.installed===true?'已安装':'未安装'}}</label></span>
                    <span class="distance fr">&nbsp;|&nbsp;</span>
                    <span class="time fr">安装员:<label style="color: #0077aa;">{{installlist.installer===null?'未指派':installlist.installer.realName}}</label></span>
                </div>

                <div class="mid">
                    <span class="count fl" v-if="installlist.setupDatetime">安装时间:<label style="color: #0077aa;">{{installlist.setupDatetime == null?'无':new Date(installlist.setupDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}</label></span>
                </div>
                <div class="mid" v-if="installlist.bookingDatetime || installlist.actualDatetime">
                                <span class="count fl" v-if="installlist.setupDatetime">
                                    预约时间:
                                    <label style="color: #0077aa;">{{installlist.bookingDatetime == null?'无':new Date(installlist.bookingDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}
                                    </label>
                                </span>
                    <span v-else>
                                    重新预约时间:
                                    <label style="color: #0077aa;">{{installlist.actualDatetime == null?'无':new Date(installlist.actualDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}
                                    </label>
                                </span>
                </div>
                <div class="mid" v-if="installlist.bookingPlace || installlist.actualPlace">
                                <span class="count fl" v-if="installlist.setupDatetime">
                                    预约地点:
                                    <label style="color: #0077aa;">{{installlist.bookingPlace == null?'无':installlist.bookingPlace}}
                                    </label>
                                </span>
                    <span v-else>
                                    重新预约地点:
                                    <label style="color: #0077aa;">{{installlist.actualPlace == null?'无':installlist.actualPlace}}
                                    </label>
                                </span>
                </div>
                <div class="mid">
                                <span class="count fl">订单状态:
                                    <label v-for="state in stateOption">
                                        <label v-if="state.value === installlist.state" style="color: red">
                                        {{state.text}}{{installlist.step == null ? '' : installlist.step.state ==1 ? '中' : installlist.step.state ==2 ? '成功' : installlist.step.state ==3 ? '失败' : ''}}
                                        </label>
                                    </label>
                                </span>

                    <span v-if="installlist.step ==null ? false : installlist.step.state != 3 ? false : true">
                                    <label>
                                        失败原因：
                                        <label style="color: red">
                                        {{installlist.step.result}}
                                        </label>
                                    </label>
                                </span>
                </div>
                <div class="mid">
                    <span class="time fr"> 配机:<label style="color: #0077aa;">{{installlist.positioningDeviceInfosCount===0?'未分配':'已分配'}}</label></span>
                    <span class="distance fr">|</span>
                    <span class="time fr"> 业务类型:<label
                            style="color: #0077aa;">{{installlist.businessType===1?'新装':installlist.businessType===2?'接入':'在网升级'}}</label></span>
                </div>
                <div class="mid">
                    <span class="count fl">服务到期时间:<label style="color: #0077aa;">{{new Date(installlist.serviceDatetime).Format('yyyy年MM月dd日')}}</label></span>
                </div>

                <div class="mid" v-if="installlist.clientInfo!=null">
                    <span class="count fl">客户姓名:<label
                            style="color: #0077aa;">{{installlist.clientInfo.name}}</label></span>
                    <span class="distance fr">|</span>
                    <span class="count fl">客户电话:<label
                            style="color: #0077aa;">{{installlist.clientInfo.phoneNum}}</label></span>
                </div>

                <div class="mid">
                    <span class="count fl">上传状态:<label style="color: #0077aa;">{{installlist.uploadState===1?'资料不完整':installlist.uploadState===2?'待上传':'已上传'}}</label></span>
                    <span class="distance fr">|</span>
                    <span class="time fr"> 开票类型:<label style="color: #0077aa;">{{installlist.billType===1?'增值说发票':installlist.billType===2?'增值税专用发票':'增值税普通发票'}}</label></span>
                </div>
                <div class="mid">
                                <span class="time fr">安装图片:<label :class="[installlist.installOrderPics.length==0?'s4':'s2']">
                                    {{installlist.installOrderPics.length==0?'未上传安装图片':'已上传：'+installlist.installOrderPics.length+'张'}}
                                </label></span>
                </div>
                <div class="mid" v-if="installlist.positioningDeviceInfos!=null">
                                <span class="time fr">主机:<label style="color: #0077aa;" v-for="item2 in installlist.positioningDeviceInfos">

                      {{item2.terminalNum+'('+item2.positioningDeviceModel.name+')'}}

                                </label></span>
                </div>
                <div class="mid">
                    <label>备注:{{installlist.remark}}</label><br>
                    <van-button size="small" type="info"
                                :disabled="disabled1" @click="addremark(installlist)">追加备注
                    </van-button>&nbsp;
<!--                    <van-button v-if="installlist.positioningDeviceInfos!=null" size="small" type="info"-->
<!--                                @click="tosetupVehicleParams(installlist)">设置车辆参数-->
<!--                    </van-button>-->
                    <br>
                    <label>追加备注:
                        <div v-if="installlist.installRemark!=null">
                            <label v-for="item2 in installlist.installRemark.split('\r\n')">{{item2}}<br></label>
                        </div>
                    </label>
                </div>
                <div class="mid">
                                <span class="count fl">历史记录:
                                    <label style="color: #0077aa;">{{installlist.history}}</label>
                                </span>
                </div>
                <div class="mid">
                    <div style="position: relative;left: 25%;margin-bottom: 5px;">
                        <van-button size="small" type="info" style="margin-right: 5px;"
                                    :disabled="disabled" @click="onChangeInstallerModal(installlist)">指派安装员
                        </van-button>
                        <van-button size="small" type="info"
                                    :disabled="disabled" @click="onReschedule(installlist)">重新预约
                        </van-button>
                    </div>
                    <div style="position: relative;left: 25%;margin-bottom: 5px;">
                        <a :href="'../installerinstallorderconfirm?installid='+installlist.id">
                            <van-button size="small" type="info" style="margin-right: 5px;"
                                        :disabled="disabled">确认流程
                            </van-button>
                        </a>
                        <van-button size="small" type="info"
                                    :disabled="disabled" @click="sueeess(installlist)">确认安装
                        </van-button>
                    </div>
                </div>

            </Card>
            <div style="height: 3px"></div>
        </div>

        <div>
            <Modal
                    v-model="modal2"
                    title="添加备注"
                    @on-ok="ok1"
                    @on-cancel="cancel1">
                <van-cell-group>
                    <van-field
                            v-model="remarkvalue"
                            rows="2"
                            autosize
                            type="textarea"
                            maxlength="250"
                            placeholder="请输入追加备注"
                            show-word-limit
                    />
                </van-cell-group>
            </Modal>
        </div>
        <bind-positioning-devices-modal v-model="bindPositioningDevicesModal" :initValue="bindPositioningDevicesId"
                                        @on-success="onModifySuccess"></bind-positioning-devices-modal>
        <bind-positioning-devices-fittings-modal v-model="bindPositioningDevicesFittingsModal"
                                                 :initValue="bindPositioningDevicesFittingsId"
                                                 @on-success="onModifySuccess"></bind-positioning-devices-fittings-modal>
        <vehicle-identificationcode-modal v-model="vehicleIdentificationcodeModal"
                                          :installed="vehicleIdentificationcodeInstalled"
                                          :initValue="vehicleIdentificationcodeId"
                                          @on-success="onFind"></vehicle-identificationcode-modal>
        <positioning-device-info-aisle-modal v-model="positioningDeviceInfoAisleModal"
                                             :initValue="positioningDeviceInfoAisleId"></positioning-device-info-aisle-modal>
        <change-installer-modal v-model="changeInstallerModal" :initValue="changeInstallerId"
                                @on-success="onback"></change-installer-modal>
        <reschedule-installer-modal v-model="rescheduleinstallermodal" :initValue="rescheduleinstallerId"
                                    @on-success="onFind"></reschedule-installer-modal>
    </div>
</template>

<script>
    import Vue from 'vue'
    import store from '@/store'
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
    import BindPositioningDevicesModal from '@/views/im/components/bind-positioning-devices-modal'
    import BindPositioningDevicesFittingsModal from '@/views/im/components/bind-positioning-devices-fittings-modal'
    import VehicleIdentificationcodeModal from '@/views/crm/components/vehicle-identificationcode-modal'
    import PositioningDeviceInfoAisleModal from '@/views/im/components/positioning-device-info-aisle-modal'
    import ChangeInstallerModal from '@/views/om/install-order/components/change-installer-modal'
    import RescheduleInstallerModal from '@/views/om/installer-install-order/components/reschedule-installer-modal'

    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
    } from 'vant'

    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast);

    export default {
        name: "setterorderDetails",
        components: {
            BindPositioningDevicesModal,
            BindPositioningDevicesFittingsModal,
            VehicleIdentificationcodeModal,
            PositioningDeviceInfoAisleModal,
            ChangeInstallerModal,
            RescheduleInstallerModal,
        },
        data() {
            return {
                //重新预约安装订单
                rescheduleinstallermodal: false,
                rescheduleinstallerId: null,

                //指派安装员
                changeInstallerModal: false,
                changeInstallerId: null,

                // 设备通道
                positioningDeviceInfoAisleModal: false,
                positioningDeviceInfoAisleId: null,

                // 车辆识别码
                vehicleIdentificationcodeModal: false,
                vehicleIdentificationcodeId: null,
                vehicleIdentificationcodeInstalled: false,


                // 安装订单配置设备
                bindPositioningDevicesModal: false,
                bindPositioningDevicesId: null,

                // 安装订单配置定位设备配件
                bindPositioningDevicesFittingsModal: false,
                bindPositioningDevicesFittingsId: null,

                installlist: [],
                discern: false,

                remarkid:null,
                disabled: false,
                disabled1: false,
                modal2: false,
                remarkvalue: '',

                stateOption:[
                    {text: '异常', value: -1},
                    {text: '作废', value: 0},
                    {text: '指派', value: 1},
                    {text: '完成', value: 2},
                    {text: '审核', value: 3},
                    {text: '配货', value: 4},
                    {text: '安装', value: 5},
                    {text: '回访', value: 6},
                    {text: '收款', value: 7},
                ]
            }
        },
        methods: {
            onChangeInstallerModal(e){
                this.changeInstallerModal = true
                this.changeInstallerId = e.id
            },
            //重新预约安装
            onReschedule(e){
                console.log(e)
                this.rescheduleinstallermodal = true
                this.rescheduleinstallerId = e.id
            },
            tosetupVehicleParams(e) {
                let qq = []
                qq.push(genQueryParam('terminalNum', 'EQ', e.positioningDeviceInfos[0].terminalNum))
                store.dispatch('Jt808DeviceServ_GetPage', {
                    params: null,
                    urlparams: {
                        q: qq
                    }
                }).then((res) => {
                    if (res.data.content.length != 0) {
                        this.$router.push({
                            path: 'setupVehicleParams',
                            query: {'upVehicleParams': e}
                        })
                    } else {
                        Toast('设备未有上线记录')
                    }
                }).catch((err) => {
                    console.log(err)
                })
            },
            //  确认安装
            sueeess(e) {
                this.disabled = true
                console.log(e)
                // this.modal1 = true
                //按名称搜索定位设备信息
                if (e.positioningDeviceInfosCount != null) {

                    //确认安装完成
                    store.dispatch('InstallOrderServ_ConfirmInstalled', {
                        params: {
                            id: e.id,
                            setupDatetime: new Date()
                        },
                        urlparams: null
                    }).then((res) => {
                        console.log(res)
                        Toast('确认成功')
                        this.disabled = false
                        // this.value2 = ''
                        this.onFind()
                    }).catch((err) => {
                        console.log(err)
                        // this.value2 = ''
                        this.disabled = false
                        Toast('确认失败' + err)
                    })
                } else {
                    Toast('未配定设备');
                }
            },
            //追加备注
            addremark(e) {
                this.modal2 = true
                this.remarkid = e.id
            },
            ok1() {
                store.dispatch('InstallOrderServ_AddToInstallRemark', {
                    params: {
                        id: this.remarkid,
                        content: this.remarkvalue
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    this.remarkvalue = ''
                    this.onFind()
                }).catch((err) => {
                    console.log(err)
                    this.remarkvalue = ''
                })
            },
            //添加备注取消
            cancel1() {
                this.remarkvalue = ''
            },
            //返回上一页
            onback() {
                this.$router.push({
                    name: 'installerinstallorder'
                })
            },
            onVehicleidentificationcodemodal(e) {
// console.log(e)
                if (e.vehicleInfoId != null) {
                    this.vehicleIdentificationcodeInstalled = true
                    this.vehicleIdentificationcodeId = e.vehicleInfoId
                    this.vehicleIdentificationcodeModal = true
                } else {
                    this.vehicleIdentificationcodeInstalled = false
                    this.vehicleIdentificationcodeId = e.id
                    this.vehicleIdentificationcodeModal = true
                }
            },
            onPositioningDeviceInfoAisleModal(e) {
                console.log(e)
                if (e.positioningDeviceInfos != null && e.positioningDeviceInfos.length > 0) {
                    this.positioningDeviceInfoAisleModal = true
                    this.positioningDeviceInfoAisleId = e.id
                } else {
                    this.$Message.error('没有绑定设备')
                }
            },
            //上传图片路径
            toUploaderimage(e) {
                console.log(e)
                this.$root.installid = e
                this.$router.push({
                    path: '/setter-Uploaderimage',
                    query: {'item': e.id}
                })
            },
            //上传图片新样式
            toTextUploaderimage(e) {
                console.log(e)
                this.$root.installid = e
                this.$router.push({
                    path: '/text-Upladerimage',
                    query: {'item': e.id}
                })
            },
            toUploaderInstallOrderImage(e) {
                // console.log(e)
                // this.$root.installid = e
                // this.$router.push({
                //     path: '/UploaderInstallOrderImage',
                //     query: {'item': e.id}
                // })
            },

            //识别行车证
            onAnalyzeVehicleLicensePicture(e) {
                this.discern = true
                //车辆信息
                store.dispatch('InstallOrderServ_GetDetail', {
                    params: {id: e},
                    urlparams: null
                }).then((res) => {


                    if (res.data.vehicleInfoId) {
                        //已完成的订单
                        //  识别行驶证
                        store.dispatch('VehicleInfoServ_AnalyzeVehicleLicensePicture', {
                            params: {id: res.data.vehicleInfoId},
                            urlparams: null
                        }).then((res) => {
                            console.log(res)
                            this.discern = false
                            this.onFind()
                        }).catch((err) => {
                            Toast(err)
                            this.discern = false
                        })
                    } else {
                        //未完成的订单

                        let installOrder = store.getters.get_InstallOrder_GetDetailResult
                        this.installOrder = installOrder
                        let vehicleInfo = this.installOrder.tempVehicleInfo
                        if (vehicleInfo.vehicleLicensePicture) {
                            //  识别行驶证
                            store.dispatch('InstallOrderServ_AnalyzeVehicleLicensePicture', {
                                params: {id: e},
                                urlparams: null
                            }).then((res) => {
                                console.log(res)
                                this.discern = false
                                this.onFind()
                            }).catch((err) => {
                                Toast(err + '请重新上传');
                                // this.$Message.error(err + '请重新上传');
                                this.discern = false
                            })
                        } else {
                            Toast('未上传行驶证');
                            // this.$Message.warning('未上传行驶证');
                            this.discern = false
                        }
                    }
                }).catch((err) => {
                    console.log(err)
                    this.discern = false
                })
            },
            // <!-- 搜索方法，默认state不为0，排除作废订单 -->
            onFind() {
                let id
                if (this.$route.query.code != null) {
                    id = this.$route.query.installid
                } else {
                    id = this.$route.query.installid
                }
                store.dispatch('InstallOrderServ_GetPage', {
                    params: null,
                    urlparams: {q: genQueryParam('id', 'EQ', id)}
                }).then((res) => {
                    console.log(res)
                    this.installlist = res.data.content[0]
                }).catch((err) => {
                    console.log(err)

                })
            },
            //缺少资料文字转换
            text1(item) {

                let text = ''
                if (item.tempVehicleInfo != null) {
                    if (!item.tempVehicleInfo.vehicleLicensePictureId) {
                        text = ' 行驶证'
                    }
                    if (!item.tempVehicleInfo.vehicleLicenseFlapPictureId) {
                        text = text + ' 行驶证副页'
                    }
                }
                return text
            },
            text2(item) {

                let text = ''
                if (item.tempVehicleInfo != null) {
                    if (!item.tempVehicleInfo.vehicleLicensePictureId) {
                        text = ' 行驶证'
                    }
                    if (!item.tempVehicleInfo.vehicleLicenseFlapPictureId) {
                        text = text + ' 行驶证副页'
                    }
                    if (!item.tempVehicleInfo.vehicleSrcLicensePicture1Id) {
                        text = text + ' 登记证1'
                    }
                }
                return text
            },
            text3(item) {

                let text = ''
                if (item.tempVehicleInfo != null) {
                    if (!item.tempVehicleInfo.vehicleLicensePictureId) {
                        text = ' 行驶证'
                    }
                    if (!item.tempVehicleInfo.vehicleLicenseFlapPictureId) {
                        text = text + ' 行驶证副页'
                    }
                    if (!item.tempVehicleInfo.vehicleSrcLicensePicture1Id) {
                        text = text + ' 登记证1'
                    }
                    if (!item.tempVehicleInfo.idFilePictureId) {
                        text = text + ' 身份识别文件'
                    }
                    if (!item.tempVehicleInfo.qghyptChangeContractPictureId) {
                        text = text + ' 转网合同'
                    }
                    if (!item.tempVehicleInfo.qghyptChangeAuthorizationPictureId) {
                        text = text + ' 授权书'
                    }
                }
                return text
                // }
            },

            getCode() { // 非静默授权，第一次有弹框
                let code = this.$route.query.code
                if (!code) {
                    code = null
                }
                // window.location.href = 'https://devwxpa.jianchengjt.com/?code=' + code
                // 你自己的业务逻辑
                //微信公众服务号登录
                store.dispatch('AccountServ_LoginByWechatServiceAccount', {
                    params: {
                        wechatCode: code
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    console.log('登陆成功')
                    // this.$router.push({
                    //     name: 'setterorderDetails',
                    // })
                })
                    .catch((err) => {
                        console.log(err)
                        console.log('登陆失败')
                        // this.$router.push({
                        //     name: 'login',
                        // })
                    })
            },
            //配机
            onBindPositioningDevicesModal(e) {
                this.bindPositioningDevicesModal = true
                this.bindPositioningDevicesId = e.id
            },
            onBindPositioningDevicesFittingsModal(e) {
                this.bindPositioningDevicesFittingsId = e.id
                this.bindPositioningDevicesFittingsModal = true
            },
        },
        mounted() {
            console.log(this.$route.query.installid)
            let id
            if (this.$route.query.code != null) {
                this.getCode()
                id = this.$route.query.installid
            } else {
                id = this.$route.query.installid
            }
            store.dispatch('InstallOrderServ_GetPage', {
                params: null,
                urlparams: {q: genQueryParam('id', 'EQ', id)}
            }).then((res) => {
                console.log(res)
                this.installlist = res.data.content[0]
            }).catch((err) => {
                console.log(err)

            })

        },
    }
</script>

<style scoped>
    .s1 {
        color: blue;
    }

    .s2 {
        color: yellowgreen;
    }

    .s3 {
        color: blueviolet;
    }

    .s4 {
        color: red;
    }

    /*月售、送达时间、距离*/
    .content .mid {
        flex: 1;
        margin-top: 7px;
        color: #666;
        font-size: 12px;
    }

</style>
